const INBOX_STORE_GET_INBOX_GETTER = 'inboxes/getInbox';
const INBOX_STORE_GET_INBOX_LABELS_GETTER = 'inboxes/getInboxLabels';
const INBOX_STORE_FETCH_INBOX_LABELS_ACTION = 'inboxes/fetchInboxLabels';
const INBOX_STORE_SYNC_FOLDERS_ACTION = 'inboxes/syncFolders';

export {
  INBOX_STORE_FETCH_INBOX_LABELS_ACTION,
  INBOX_STORE_GET_INBOX_GETTER,
  INBOX_STORE_GET_INBOX_LABELS_GETTER,
  INBOX_STORE_SYNC_FOLDERS_ACTION,
};
